/* eslint-disable react/no-unused-prop-types,no-console,
react/no-danger,react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// material-ui/ core components
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import RouterContext from 'helpers/routerContext';
import Lightbox from 'react-image-lightbox';
import defaultImage from 'assets/img/default_image.jpg';

/**
 * @description - AdList component
 * @augments React.Component
 */
class ImageMosaic extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      showImageViewer: false,
      currentPhotoIndex: -1,
    };
  }

  /**
   * @description
   * Render Filter, Paginator and ReactTable components.
   * @returns {*} Filter, Paginator and ReactTable components.
   */
  render() {
    const { images, classes } = this.props;
    const { currentPhotoIndex, showImageViewer } = this.state;
    const imageUrls = images.map(img => img.high);

    return (
      <div>
        {images.map((img, key) => (
          <a
            data-cy="adImage"
            key={img.id}
            href={img.high}
            onClick={event => {
              event.preventDefault();
              this.setState({
                currentPhotoIndex: key,
                showImageViewer: true,
              });
            }}
          >
            <img
              src={img.thumb || defaultImage}
              alt=""
              className={classes.adImage}
              onError={e => {
                e.target.onerror = null;
                e.target.src = defaultImage;
              }}
            />
          </a>
        ))}
        {showImageViewer && (
          <Lightbox
            mainSrc={imageUrls[currentPhotoIndex]}
            nextSrc={imageUrls[(currentPhotoIndex + 1) % imageUrls.length]}
            prevSrc={
              imageUrls[
                (currentPhotoIndex + imageUrls.length - 1) % imageUrls.length
              ]
            }
            onCloseRequest={() => this.setState({ showImageViewer: false })}
            onMovePrevRequest={() =>
              this.setState({
                currentPhotoIndex:
                  (currentPhotoIndex + imageUrls.length - 1) % imageUrls.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                currentPhotoIndex: (currentPhotoIndex + 1) % imageUrls.length,
              })
            }
          />
        )}
      </div>
    );
  }
}

/**
 * AdList PropTypes
 * @param classes - prop styles received from withStyles
 * @param images - prop images received from parents
 */

ImageMosaic.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  images: PropTypes.instanceOf(Array).isRequired,
};

// to fix: The withStyles HOC set contextTypes to a children component
// and it have problem with contextType assigned to PermissionList component
// This is a small hack, with intermediary Component to resolved it temporally
const ImageMosaicWrapper = props => <ImageMosaic {...props} />;

export default withTranslation()(
  withStyles(extendedTablesStyle)(ImageMosaicWrapper),
);
